<template>
  <el-dialog :visible.sync="dialogVisible" :show-close="false">
    <img
      class="close-img"
      src="@/assets/img/images/icon/close-icon.png"
      @click="dialogVisible = false"
    />
    <p class="p2 mt20">{{ verifyHint }}</p>
    <el-form class="mt20">
      <el-form-item :label="$t('register.code')" prop="verifyCode">
        <el-input
          v-model="verifyData.verifyCode"
          :placeholder="$t('tipsVal.inputPlaceholder1')"
        >
          <template slot="append" v-if="verifyData.verifyType != 'google'"
            ><span v-if="!phoneCodeStatus.hasSend" @click="hasSendPhoneCode">
              {{ $t("password_recovery.getCode") }}</span
            >
            <span v-else>{{ phoneCodeStatus.times }}</span></template
          ></el-input
        >
      </el-form-item>
    </el-form>
    <div class="btn-box">
      <div class="btn1" @click="dialogVisible = false">
        {{ $t("buy_box.cancel") }}
      </div>
      <div class="btn2" :loading="verifyLoading" @click="shouTipsClick">
        {{ $t("buy_box.verification") }}
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      verifyLoading: false,
      dialogVisible: false,
      captchaObj: null,

      phoneCodeStatus: {
        hasSend: false,
        times: 60,
      },
      verifyData: {
        hint: "短信验证码已发送至手机",
        token: "",
        verifyCode: "",
        verifyType: "",
      },
    };
  },
  computed: {
    ...mapState(["user", "errorCode"]),
    //按verifyType前端写死提示文案，支持多语言切换
    verifyHint() {
      if (this.verifyData.verifyType === "google") {
        return this.$t("login.hint_google");
      }
      if (this.verifyData.verifyType === "email") {
        return this.$t("login.hint_email");
      }
      return this.$t("login.hint_default");
    },
  },
  mounted() {
    let this_vue = this;
    this.$axios
      .post("/geetest/startCaptcha?t=" + new Date().getTime())
      .then((res) => {
        //console.log(res);
        let data = res.data;
        initGeetest(
          {
            gt: data.gt,
            challenge: data.challenge,
            offline: !data.success,
            new_captcha: true,
            product: "bind",
          },
          function (captchaObj) {
            this_vue.captchaObj = captchaObj;
            captchaObj
              .onReady(function () {
                // $("#wait").hide();
              })
              .onSuccess(function () {
                let result = captchaObj.getValidate();
                if (!result) {
                  this_vue.$message({
                    type: "error",
                    message: this_vue.$t("validate.geet_require"),
                  });
                } else {
                  this_vue.$axios
                    .post("/geetest/verifyLogin", {
                      challenge: data.challenge,
                      geetest_challenge: result.geetest_challenge,
                      geetest_validate: result.geetest_validate,
                      geetest_seccode: result.geetest_seccode,
                    })
                    .then((res) => {});
                }
              });
          },
        );
      });
  },
  methods: {
    init(obj) {
      this.verifyData = obj;
      this.dialogVisible = true;
      this.timeChange();
    },
    timeChange() {
      this.phoneCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.phoneCodeStatus.times <= 0) {
          this.phoneCodeStatus.hasSend = false;
          this.phoneCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.phoneCodeStatus.times--;
        }
      }, 1000);
    },
    hasSendPhoneCode() {
      this.phoneCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.phoneCodeStatus.times <= 0) {
          this.phoneCodeStatus.hasSend = false;
          this.phoneCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.phoneCodeStatus.times--;
        }
      }, 1000);
      this.captchaObj.verify();
    },
    shouTipsClick() {
      if (!this.verifyData.verifyCode.trim()) {
        this.$message({
          type: "error",
          message: this.$t("validate.code_require"),
        });
      } else {
        this.verifyLoading = true;
        this.$axios
          .post("/user/signInConfirm", this.verifyData)
          .then((res) => {
            this.dialogVisible = false;
            this.verifyLoading = false;
            if (res.data.code === this.errorCode.ok) {
              window.localStorage.setItem("jwt-token", res.data.data.jwtToken);
              this.$store.commit("userLogin", res.data.data);
              this.$store.commit("updateToken", res.data.data.jwtToken);
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          })
          .catch(() => {
            this.verifyLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 540px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px 30px;
  }
  .el-form-item__label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    // margin-bottom: 16px;
  }
  .el-input-group__append {
    border: none;
    background: rgba(214, 216, 219, 0.3);
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 16px;
    color: #333333;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}

/deep/.el-input__inner {
  border-radius: 8px;
}
/deep/.el-input-group--append {
  gap: 16px;
  display: flex;
}
/deep/.el-input-group__append {
  cursor: pointer;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid var(--primary-color);
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: var(--primary-color);
  padding: 0 24px;
  width: auto;
  display: flex;
  align-items: center;
}
.mt8 {
  margin-top: 8px;
}
.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 36px;
  color: #333333;
}
.p2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.p3 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}
.sp1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
}
.sp2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 32px;
  color: var(--primary-color);
}
.box1 {
  width: 480px;
  height: 160px;
  overflow: hidden;
  padding-left: 20px;
  background: #ffffff;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 12px 12px 12px 12px;
  background-image: url(~@/assets/img/images/member-bj.png);
}
.close-img {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  position: absolute;
}
.btn-box {
  gap: 10px;
  display: flex;
  margin-top: 32px;
  .btn1 {
    flex: 1;
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid var(--primary-color);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: var(--primary-color);
  }
  .btn2 {
    flex: 1;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: var(--primary-color);
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
  }
}
</style>
